import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import {
  APPROVAL_LIST,
  ACCEPT,
  REJECT,
  INS_APPROVAL_LIST,
  INS_DETAILS_LIST,
  LEAD_APPROVAL_LIST,
  EXISTING_PROJECT_LIST,
  TAG_APPROVAL_LIST,
  TAG_DETAILS_LIST,
  SAVE_LOGS_FOR_CONTRACT
} from "./type";
import { STATUS } from "constants/statusConstant";
import {toast} from "react-toastify";

export const getApprovalList = (queryObj = null, page = 1) => async (
  dispatch
) => {

  console.log(queryObj)
  let filterQuery = "";
  if (queryObj !== null) {
    filterQuery = `?lead_id=${queryObj.leadID}&status=${queryObj.leadStatus}&client_name=${queryObj.clientNameOrPartnerName}&created_on=${queryObj.createdOnDate}&from_date=${queryObj.fromDate}&to_date=${queryObj.toDate}&assigned_to=${queryObj.leadOwnerOrAssignee}&city=${queryObj.city}&zone=${queryObj.zone}&commercial_type_id=${queryObj.commercial_type_id}&page=${page}`;
  }

  const teamName = await JSON.parse(localStorage.getItem("profileDetails"))[0]
    .team_id;


    var teams = await JSON.parse(localStorage.getItem("profileDetails"));
    var teamId = [];
    teams.forEach((team, index) => {
      teamId.push(team.team_id);
    });
    console.log(teamId);
    if (queryObj !== null) {
      filterQuery += `&teamId=${teamId}`;
    }

  const departmentName = await JSON.parse(
    localStorage.getItem("profileDetails")
  )[0].department_id;

  let apiUrl;
  // approvalContractAptAllList
  if (departmentName && departmentName === 2) {

       apiUrl = queryObj
        ? `${Config.preSalesList.approvalContractAptAllList}${filterQuery}`
        : Config.preSalesList.approvalContractAptAllList;


    // if (teamName && teamName === 7) {
    //   apiUrl = queryObj
    //     ? `${Config.preSalesList.approvalContractList}${filterQuery}`
    //     : Config.preSalesList.approvalContractList;
    // } else if (teamName && teamName === 9) {
    //   apiUrl = queryObj
    //     ? `${Config.preSalesList.approvalContractSupplyList}${filterQuery}`
    //     : Config.preSalesList.approvalContractSupplyList;
    // } else if (teamName && teamName === 8) {
    //   apiUrl = queryObj
    //     ? `${Config.preSalesList.approvalContractAptList}${filterQuery}`
    //     : Config.preSalesList.approvalContractAptList;
    // } else {
    //   apiUrl = queryObj
    //     ? `${Config.preSalesList.listAlliance}${filterQuery}`
    //     : Config.preSalesList.listAlliance;
    // }
  } else if(teamName && teamName === 16) {
    apiUrl = queryObj
        ? `${Config.preSalesList.approvalContractSupplyList}${filterQuery}`
        : Config.preSalesList.approvalContractSupplyList;
  } else if(teamId.includes(21)) {
    apiUrl = queryObj
        ? `${Config.preSalesList.approvalAllContractList}${filterQuery}`
        : Config.preSalesList.approvalAllContractList;
  }

  const res = await callWebService(
    callTypes.get,
    "",
    `${apiUrl}?status=${STATUS.STATUS_APPROVE_PENDING}&page=${page}&teamId=${teamId}`
  );
  if (res) {
    const outer = res.data;
    const payload = outer?.response ?? outer;
    dispatch({ type: APPROVAL_LIST, payload: payload?.data ?? outer?.data });
    return true;
  }
};

export const getInspectionApprovalList = (queryObj = null, page = 1) => async (
  dispatch
) => {
  let filterQuery = "";
  if (queryObj !== null) {
    filterQuery = `?lead_id=${queryObj.leadID}&status=${queryObj.leadStatus}&client_name=${queryObj.clientNameOrPartnerName}&created_on=${queryObj.createdOnDate}&from_date=${queryObj.fromDate}&to_date=${queryObj.toDate}&assigned_to=${queryObj.leadOwnerOrAssignee}&city=${queryObj.city}&zone=${queryObj.zone}&page=${page}`;
  }

  const userId = await JSON.parse(localStorage.getItem("loginDetails"));

  const teamName = await JSON.parse(localStorage.getItem("profileDetails"))[0]
    .team_id;

  const departmentName = await JSON.parse(
    localStorage.getItem("profileDetails")
  )[0].department_id;

  let apiUrl;

  if (departmentName && departmentName === 2) {
    if ((teamName && teamName === 7) || (userId && userId?.id === 1016)) {
      apiUrl = queryObj
        ? `${Config.preSalesList.inspectionApprovalContractList}${filterQuery}&lead_type=1`
        : `${Config.preSalesList.inspectionApprovalContractList}?lead_type=1`;
    } else if (teamName && teamName === 9) {
      apiUrl = queryObj
        ? `${Config.preSalesList.inspectionApprovalContractList}${filterQuery}&lead_type=4`
        : `${Config.preSalesList.inspectionApprovalContractList}?lead_type=4`;
    } else if (teamName && teamName === 8) {
      apiUrl = queryObj
        ? `${Config.preSalesList.inspectionApprovalAptContractList}${filterQuery}`
        : `${Config.preSalesList.inspectionApprovalAptContractList}`;
    } else {
      apiUrl = queryObj
        ? `${Config.preSalesList.listAlliance}${filterQuery}`
        : Config.preSalesList.listAlliance;
    }
  } else if(teamName && teamName === 16) {
    apiUrl = queryObj
    ? `${Config.preSalesList.inspectionApprovalContractList}${filterQuery}&lead_type=4`
    : `${Config.preSalesList.inspectionApprovalContractList}?lead_type=4`;
  }
  const separator = apiUrl.includes('?') ? '&' : '?';
  const res = await callWebService(
    callTypes.get,
    "",
    `${apiUrl}${separator}status=${STATUS.STATUS_APPROVE_PENDING}&page=${page}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: INS_APPROVAL_LIST, payload: data.response?.data ?? data.data });
    return true;
  }
};

// Inspection details
export const inspectionApprovalDetails = (inspection_id) => async (
  dispatch
) => {
  

  let apiUrl = `${Config.preSalesList.inspectionApprovalDetails}`;


  const res = await callWebService(
    callTypes.get,
    "",
    `${apiUrl}?inspection_id=${inspection_id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: INS_DETAILS_LIST, payload: data.response?.data ?? data.data });
    return true;
  }
};

export const inspectionPostSolution = (data) => async(
  dispatch
) =>{
  // console.log(data); return false;
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.preSalesList.inspectionPostSolution}`
  );
  const payload = res?.data?.data ?? res?.data?.response?.data;
  if (payload) {
    console.log(payload);
    return payload;
  }
  return false;
};
export const inspectionReject = (data) => async(
  dispatch
) =>{
  // console.log(data); return false;
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.preSalesList.inspectionReject}`
  );
  const payload = res?.data?.data ?? res?.data?.response?.data;
  if (payload) {
    console.log(payload);
    return payload;
  }
  return false;
};


export const acceptApproval = (requestData) => async (dispatch) => {
  dispatch({ type: ACCEPT, payload: null });
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.approvals.accept
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: "", payload: data.response.data });
    return true;
  }
};

export const rejectApproval = (requestData) => async (dispatch) => {
  dispatch({ type: REJECT, payload: null });
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.approvals.reject
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: "", payload: data.response.data });
    return true;
  }
};


export const getLeadApprovalList = (queryObj = null, page = 1) => async (
  dispatch
) => {
  let filterQuery = "";
  if (queryObj !== null) {
    filterQuery = `?lead_id=${queryObj.leadID}&client_name=${queryObj.clientNameOrPartnerName}&created_on=${queryObj.createdOnDate}&from_date=${queryObj.fromDate}&to_date=${queryObj.toDate}&assigned_to=${queryObj.leadOwnerOrAssignee}&city=${queryObj.city}&zone=${queryObj.zone}&page=${page}`;
  }

  const teamName = await JSON.parse(localStorage.getItem("profileDetails"))[0]
    .team_id;

  const departmentName = await JSON.parse(
    localStorage.getItem("profileDetails")
  )[0].department_id;

  let apiUrl = `${Config.preSalesList.leadApprovalList}${filterQuery}`;

  const res = await callWebService(
    callTypes.get,
    "",
    `${apiUrl}?page=${page}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: LEAD_APPROVAL_LIST, payload: data.response?.data ?? data.data });
    return true;
  }
};

export const acceptLeadApproval = (requestData) => async (dispatch) => {
  dispatch({ type: ACCEPT, payload: null });
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.approvals.acceptLead
  );
  const statusOk =
    res?.data?.status === 0 || res?.data?.response?.status === true;
  const message =
    res?.data?.message ||
    res?.data?.response?.message ||
    res?.data?.response?.success;
  if (statusOk) {
    if (message) {
      toast.success(message);
    }
    const { data } = res;
    dispatch({ type: "", payload: data?.response?.data ?? data?.data });
    return true;
  }
  if (message) {
    toast.warning(message);
  }
};

export const rejectLeadApproval = (requestData) => async (dispatch) => {
  dispatch({ type: REJECT, payload: null });
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.approvals.rejectLead
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: "", payload: data.response.data });
    return true;
  }
};

export const getExistingProject = (val) => async (dispatch) => {
console.log(val);
  const {
    client_name,
    latitude,
    longitude,
    lead_sub_type,
    lead_type_id,
  } = val;

  const projectData = {
   
    project_name: `${client_name}`,
    // current_location: `${currentLocation}`,
    lat: `${latitude}`,
    lng: `${longitude}`,
    society_type: lead_sub_type,
    project_type: (lead_type_id === 4) ? lead_sub_type:lead_type_id,
  };



  const res = await callWebService(
    callTypes.post,
    projectData,
    Config.preSalesList.checkProjectExist
  );
  if (res) {
    const { data } = res;
    dispatch({ type: EXISTING_PROJECT_LIST, payload: data.response.data });
    return true;
  }
};

export const getTagMismatchApprovalList = (queryObj = null, page = 1) => async (
  dispatch
) => {
  let filterQuery = "";
  if (queryObj !== null) {
    filterQuery = `?lead_id=${queryObj.leadID}&status=${queryObj.leadStatus}&client_name=${queryObj.clientNameOrPartnerName}&created_on=${queryObj.createdOnDate}&from_date=${queryObj.fromDate}&to_date=${queryObj.toDate}&assigned_to=${queryObj.leadOwnerOrAssignee}&city=${queryObj.city}&zone=${queryObj.zone}&page=${page}`;
  }
  const teamName = await JSON.parse(localStorage.getItem("profileDetails"))[0]
    .team_id;

  const departmentName = await JSON.parse(
    localStorage.getItem("profileDetails")
  )[0].department_id;

  let apiUrl;

  if (departmentName && departmentName === 2) {
    if (teamName && teamName === 7) {
      apiUrl = queryObj
        ? `${Config.preSalesList.tagMismatchApprovalList}${filterQuery}&lead_type=1`
        : `${Config.preSalesList.tagMismatchApprovalList}?lead_type=1`;
    } else if (teamName && teamName === 9) {
      apiUrl = queryObj
        ? `${Config.preSalesList.tagMismatchApprovalList}${filterQuery}&lead_type=4`
        : `${Config.preSalesList.tagMismatchApprovalList}?lead_type=4`;
    } else if (teamName && teamName === 8) {
      apiUrl = queryObj
        ? `${Config.preSalesList.tagMismatchApprovalList}${filterQuery}`
        : `${Config.preSalesList.tagMismatchApprovalList}`;
    }
  } else if(teamName && teamName === 16) {
    apiUrl = queryObj
      ? `${Config.preSalesList.tagMismatchApprovalList}${filterQuery}&lead_type=4`
      : `${Config.preSalesList.tagMismatchApprovalList}?lead_type=4`;
  }

  const separator = apiUrl.includes("?") ? "&" : "?";
  const res = await callWebService(
    callTypes.get,
    "",
    `${apiUrl}${separator}page=${page}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: TAG_APPROVAL_LIST, payload: data.response?.data ?? data.data });
    return true;
  }
};

export const tagApprovalDetails = (inspection_id) => async (
  dispatch
) => {
  let apiUrl = `${Config.preSalesList.tagApprovalDetails}`;
  const res = await callWebService(
    callTypes.get,
    "",
    `${apiUrl}?inspection_id=${inspection_id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: TAG_DETAILS_LIST, payload: data.response.data });
    return true;
  }
};

export const tagMismatchApprove = (data) => async (
  dispatch
) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.preSalesList.tagMismatchApproval}`
  );
  if (res?.data?.status === 0 || res?.data?.response?.status === true) {
    return true;
  }
  return false;
};

export const tagMismatchReject = (data) => async(
  dispatch
) =>{
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.preSalesList.tagMismatchReject}`
  );
  const payload = res?.data?.data ?? res?.data?.response?.data;
  if (payload) {
    return payload;
  }
  return false;
};


export const saveAllContractLogs = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.approvals.saveContractLogs
  );
  if (res) {
    const { data } = res;
    dispatch({ type: SAVE_LOGS_FOR_CONTRACT, payload: data.response.data });
    return true;
  }
};